<script lang="ts">
  import { resolveStatusColor } from "@kontextwerk/web-sdk/core/display/status"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { PlanningPreviewRouteAnchorTag } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    anchor?: PlanningPreviewRouteAnchorTag | null
    emptyLabel: string
    emptyTooltip: string
  }

  const { anchor = null, emptyLabel, emptyTooltip }: Props = $props()
  const metricLabel = $derived(anchor?.metricLabel?.trim() ?? "")
  const metricAriaLabel = $derived(anchor?.metricAriaLabel?.trim() || metricLabel)
  const anchorColor = $derived(resolveStatusColor(anchor?.color ?? "gray"))
</script>

<div class="route-anchor-cell">
  {#if anchor}
    <span class="route-anchor-cell__tag" style={`--route-anchor-color:${anchorColor};`}>
      <StatusTag
        variant="neutral"
        class="route-anchor-status-tag"
        size="sm"
        label={anchor.label}
        subLabel={anchor.subLabel ?? undefined}
        color={anchor.color}
        tooltipContent={anchor.tooltip ?? ""}
        tooltipHtml={anchor.tooltipHtml ?? false}
        tooltipClassName={RICH_TOOLTIP_CLASS}
        disableTitle={true}
      />
      {#if metricLabel}
        <span class="route-anchor-cell__metric" aria-label={metricAriaLabel}>{metricLabel}</span>
      {/if}
    </span>
  {:else}
    <StatusTag
      variant="neutral"
      size="sm"
      label={emptyLabel}
      color="#64748b"
      tooltipContent={emptyTooltip}
      disableTitle={true}
    />
  {/if}
</div>

<style lang="less">
  .route-anchor-cell {
    display: flex;
    align-items: flex-start;
    min-width: 11.5rem;
  }

  .route-anchor-cell__tag {
    display: inline-flex;
    align-items: stretch;
    max-width: 15rem;
  }

  .route-anchor-cell__metric {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.9rem;
    padding: 0.2rem 0.35rem;
    border: 1px solid var(--route-anchor-color, var(--text-invers-100));
    border-left: 0;
    background: var(--route-anchor-color, var(--text-invers-100));
    color: #fff;
    font-size: 0.72rem;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    line-height: 1;
    white-space: nowrap;
  }

  .route-anchor-cell :global(.route-anchor-status-tag) {
    max-width: 11.6rem;
  }

  .route-anchor-cell :global(.route-anchor-status-tag .status-tag__main-label),
  .route-anchor-cell :global(.route-anchor-status-tag .status-tag__sub-label) {
    max-width: 10.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
